module.exports = __webpack_public_path__ + "img/list_Character_sq_21.f1165883.jpeg";